<template>
    <div class="p-3">
        <canvas ref="canvas" class="col-md-7"></canvas>
    </div>
</template>

<script>
import { defineComponent, ref, onMounted, watch, nextTick } from 'vue';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale } from 'chart.js';

ChartJS.register(BarElement, CategoryScale, LinearScale);

export default defineComponent({
    name: 'CategoryBarChart',
    props: {
        chartData: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const canvas = ref(null);
        let chartInstance = null;

        const renderChart = () => {
            if (chartInstance) {
                chartInstance.destroy();
            }
            nextTick(() => {
                const context = canvas.value.getContext('2d');
                chartInstance = new ChartJS(context, {
                    type: 'bar',
                    data: props.chartData,
                    options: props.options
                });
            });
        };

        onMounted(renderChart);

        watch(() => props.chartData, renderChart, { deep: true });

        return { canvas };
    }
});
</script>

<style scoped>
canvas {
    max-width: 800px;
    margin: auto;
}
</style>
